import Badge from 'components/molecules/Badge';
import PremiumBadge from 'components/molecules/PremiumBadge';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

interface SlotBoxProps {
  onSelected?: () => any;
  isSelected?: boolean;
  title?: string;
  description?: string;
  variant?: 'date' | 'slot';
  isAvailable: boolean;
  boxRef: React.Ref<HTMLDivElement>;
  className?: string;
  isUrgent?: boolean;
  isPremiumTimeSlot?: boolean;
}

const StyledSlotBox = styled.div<{ isSelected: boolean; isAvailable: boolean; isUrgent: boolean }>`
  cursor: ${({ isAvailable }) => (isAvailable ? 'pointer' : 'default')};
  background: ${({ theme, isSelected, isAvailable }) =>
    !isAvailable ? theme.colors.light : isSelected ? theme.components.pages.pickupDropoff?.bottomSheet?.timeSlot?.background : '#FFFF'};
  border-radius: 8px;
  padding: 0.5rem 1rem;
  min-height: ${({ isUrgent }) => (isUrgent ? 'calc(4.1rem + 20px)' : '4.1rem')};
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 0.25rem 0;
  border: solid;
  color: ${({ isSelected }) => (isSelected ? '#FFFF !important' : undefined)};
  border-width: ${({ theme }) => theme.components.card.border.width || 1}px;
  border-color: ${({ theme, isSelected }) =>
    isSelected
      ? theme.components.pages.pickupDropoff?.bottomSheet?.timeSlot?.borderColor.selected
      : theme.components.pages.pickupDropoff?.bottomSheet?.timeSlot?.borderColor.unselected};
`;

const StyledTitle = styled.h4<{ isSelected: boolean; isAvailable: boolean }>`
  margin-bottom: 0px;
  font-weight: ${({ isSelected }) => (isSelected ? 500 : 400)};
  color: ${({ theme, isSelected, isAvailable }) =>
    !isAvailable ? theme.colors.cadetBlue : isSelected ? theme.text.slotBoxTextColor : theme.colors.dark};
  text-decoration: ${({ isAvailable }) => (isAvailable ? undefined : 'line-through')};
`;

const StyledDescription = styled.h5<{ isSelected: boolean; isAvailable: boolean }>`
  margin-bottom: 0px;
  font-weight: 300;
  color: ${({ theme, isSelected, isAvailable }) =>
    !isAvailable ? theme.colors.cadetBlue : isSelected ? theme.text.slotBoxTextColor : theme.text.subtitleText};
`;

const SlotBox: React.FC<SlotBoxProps> = ({
  isSelected = false,
  isAvailable,
  boxRef,
  onSelected,
  variant = 'date',
  description,
  title,
  className,
  isUrgent = false,
  isPremiumTimeSlot = false,
}) => {
  const { t } = useTranslation();

  if (!isAvailable) {
    return null;
  }

  return (
    <StyledSlotBox ref={boxRef} onClick={onSelected} isSelected={isSelected} isAvailable={isAvailable} isUrgent={isUrgent} className={className}>
      <div>
        {variant === 'date' && (
          <StyledTitle isSelected={isSelected} isAvailable={isAvailable}>
            {title}
          </StyledTitle>
        )}
        {description && (
          <StyledDescription isSelected={isSelected} isAvailable={isAvailable}>
            {description}
          </StyledDescription>
        )}
        {variant === 'slot' && (
          <StyledTitle isSelected={isSelected} isAvailable={isAvailable}>
            {title}
          </StyledTitle>
        )}
        <div className="d-flex">
          {isUrgent && <Badge content={t('newOrderPage.surcharge50')} />}
          {isPremiumTimeSlot && <PremiumBadge active={isSelected} />}
        </div>
      </div>
    </StyledSlotBox>
  );
};

export default SlotBox;
